import React, { Component } from 'react';
import { Menu, Dropdown, Icon, Avatar, Badge, List } from 'antd';
import { logout } from '../../../actions/appAction';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { 
    RTLButton, 
    RTLMenuItem, 
    RTLListItem, 
    RTLListItemMeta,
    RTLMenu } from '../../RTLKit';
import Logout from '../../logout/Logout';


const mapDispatchToProps = dispatch => ({
      onLogout: event => {
        dispatch(logout());
      }
});


const data = [];
// const data = [
//     {
//         title: 'فدراسیون فوتبال: پاتوسی در لیگ قهرمانان بازی می‌کند'
//     },
//     {
//         title: 'ترکیب احتمالی پرسپولیس برابر نفت مسجد سلیمان'
//     },
//     {
//         title: 'دخسوس: روز خوبم با بدترین روز عوض شد'
//     },
//     {
//         title: 'رقیب پرسپولیس بدون ژاوی در کلاسیکوی دوحه'
//     },
//     {
//         title: 'یاران زخم خورده طارمی به رقیب استقلال رسیدند'
//     }
//   ];


const NewList = styled(List)`
  top: 8px !important;
`;

const messageList = (
    <NewList
      size="small"
      bordered
      dataSource={data}
      renderItem={item => (
        <RTLListItem>
          <RTLListItemMeta
            avatar={<Avatar icon="message" size="small" style={{ backgroundColor: '#87d068' }}/>}
            title={item.title}
          />
        </RTLListItem>
      )}
    />
);

const menu = (
    <RTLMenu style={{fontWeight: 'bolder'}}>
      <RTLMenuItem key="0">
      <span><Icon type="wallet" /><span>حسابداری</span></span>
      </RTLMenuItem>
      <RTLMenuItem key="1">
      <span><Icon type="profile" /><span>پروفایل</span></span>
      </RTLMenuItem>
      <Menu.Divider />
      <RTLMenuItem key="3">
      <span style={{color: 'red'}}><Icon type="logout" /><span>خروج</span></span>
      </RTLMenuItem>
    </RTLMenu>
  );

  const menuActions = (
    <RTLMenu>
      <RTLMenuItem key="1">
          <a href="/#/order/add">
            <Icon type="plus-circle" theme="twoTone" />ایجاد مشتری و ثبت سفارش
          </a>
      </RTLMenuItem>
      <RTLMenuItem key="2">
          <a href="/#/user/list">
              <Icon type="plus-circle" theme="twoTone" />لیست کاربران
          </a>
      </RTLMenuItem>
    </RTLMenu>
  );

class UserMenu extends Component {
    render () {
        return(
            <React.Fragment>
                <Dropdown overlay={menuActions}>
                    <RTLButton type="primary" shape="round" style={{marginLeft: '20px', width: '150px'}}>
                        عملیات <Icon type="caret-down" />
                    </RTLButton>
                </Dropdown>
                <Dropdown overlay={messageList} trigger={['click']} placement="bottomLeft">
                    <span style={{ marginLeft: '10px' }}>
                        {/*<Badge count={3}><Avatar shape="circle" icon="message" /></Badge>*/}
                        <Avatar shape="circle" icon="message" />
                    </span>
                </Dropdown>
                {/*<Dropdown overlay={menu} trigger={['click']} placement="bottomLeft">*/}
                {/*    <a href="/">*/}
                {/*    <Icon type="caret-down" /> <Avatar icon="user" />*/}
                {/*    </a>*/}
                {/*</Dropdown>*/}
                <Logout />
            </React.Fragment>
        );
    }
}
// export default UserMenu;
export default connect(null, mapDispatchToProps)(UserMenu);